"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CadSemanticFileTypeSchema = void 0;
const zod_1 = require("zod");
exports.CadSemanticFileTypeSchema = zod_1.z.enum([
    'board',
    'schematic',
    'lib',
    'dru',
    'project',
    'other',
    'bom',
    'stackup',
    'netlist',
]);
//# sourceMappingURL=CadSemanticFileType.js.map